var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAStorageBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#2A4DC2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 24V33",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.39 30.3895C33.3653 29.8578 34.1358 29.0164 34.5798 27.9981C35.0239 26.9799 35.1162 25.8427 34.8422 24.7662C34.5682 23.6896 33.9434 22.735 33.0666 22.0529C32.1898 21.3709 31.1108 21.0002 30 20.9995H28.74C28.4373 19.8287 27.8731 18.7418 27.0899 17.8205C26.3067 16.8991 25.3248 16.1673 24.2181 15.6801C23.1113 15.1929 21.9085 14.9629 20.7001 15.0074C19.4916 15.0519 18.309 15.3698 17.2411 15.9372C16.1732 16.5045 15.2479 17.3066 14.5346 18.2831C13.8213 19.2596 13.3387 20.385 13.1229 21.5749C12.9072 22.7647 12.9641 23.988 13.2892 25.1528C13.6143 26.3175 14.1992 27.3934 15 28.2995",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 28L24 24L20 28",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAStorageBlue);
export default __webpack_public_path__ + "static/media/a_storage_blue.4f53253c7e38d550191a6d125e0c6a45.svg";
export { ForwardRef as ReactComponent };